export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 3,
    "title": "What are the three main objectives of a cybersecurity program?",
    "description": "Confidentiality, Integrity, and Availability."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "What term is commonly used to describe the senior-most information security leader in an organization?",
    "description": "Chief Information Security Officer (CISO)."
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "What are the four roles assigned to individuals and teams in an RACI matrix?",
    "description": "Responsible, Accountable, Consulted, and Informed."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What type of risk threatens to make an organization less effective at meeting its goals and objectives?",
    "description": "Strategic risk."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "What technique do organizations commonly use to assess internal and external factors that might affect their cybersecurity strategy?",
    "description": "Strengths, Weaknesses, Opportunities, and Threats (SWOT) analysis."
  },
  {
    "id": 6,
    "topic_id": 2,
    "title": "What are the levels of the CMMI model?",
    "description": "Initial."
  },
  {
    "id": 7,
    "topic_id": 2,
    "title": "What are the characteristics of a SMART goal?",
    "description": "Specific."
  },
  {
    "id": 8,
    "topic_id": 3,
    "title": "What are the three major categories of security control?",
    "description": "Technical, Operational, Managerial."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "What are the six types of security controls?",
    "description": "Preventive, Detective, Corrective, Deterrent, Physical, and Compensating."
  },
  {
    "id": 10,
    "topic_id": 3,
    "title": "What technology uses mathematical algorithms to protect information from prying eyes?",
    "description": "Encryption."
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "What are the three major data obfuscation techniques?",
    "description": "Hashing, tokenization, and masking."
  },
  {
    "id": 12,
    "topic_id": 3,
    "title": "What person or entity has ultimate authority over a public company?",
    "description": "Board of directors."
  },
  {
    "id": 13,
    "topic_id": 3,
    "title": "What individual in an organization bears primary responsibility for achieving the organization\u2019s mission?",
    "description": "Chief Executive Officer (CEO)."
  },
  {
    "id": 14,
    "topic_id": 3,
    "title": "What are the major elements of an information security business case?",
    "description": "Scope statement."
  },
  {
    "id": 15,
    "topic_id": 3,
    "title": "What type of agreement provides an umbrella contract for work that a vendor does with an organization over an extended period of time?",
    "description": "Master Services Agreement (MSA)."
  },
  {
    "id": 16,
    "topic_id": 3,
    "title": "What type of agreement is designed specifically to protect the confidentiality of information shared between two entities?",
    "description": "Nondisclosure agreement (NDA)."
  },
  {
    "id": 17,
    "topic_id": 4,
    "title": "What are the elements of the information security policy framework?",
    "description": "Policies, standards, guidelines, and procedures."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "If an organization is unable to meet a regulatory requirement, what type of control may it implement in place of that requirement?",
    "description": "Compensating control."
  },
  {
    "id": 19,
    "topic_id": 3,
    "title": "What law provides cybersecurity standards that affect healthcare providers in the United States?",
    "description": "Health Insurance Portability and Accountability Act (HIPAA)."
  },
  {
    "id": 20,
    "topic_id": 4,
    "title": "What law provides cybersecurity standards that affect financial institutions in the United States?",
    "description": "Gramm\u2013Leach\u2013Bliley Act (GLBA)."
  },
  {
    "id": 21,
    "topic_id": 3,
    "title": "What is the name of the IT management and governance framework promulgated by ISACA?",
    "description": "Control Objectives for Information Technology (COBIT)."
  },
  {
    "id": 22,
    "topic_id": 3,
    "title": "What are the implementation tiers of the NIST Cybersecurity Framework?",
    "description": "Partial."
  },
  {
    "id": 23,
    "topic_id": 4,
    "title": "What are the two factors that must combine to create a risk?",
    "description": "Threat and vulnerability."
  },
  {
    "id": 24,
    "topic_id": 3,
    "title": "What type of risks impact more than one organization?",
    "description": "Multiparty risks."
  },
  {
    "id": 25,
    "topic_id": 3,
    "title": "What two elements do we consider when determining the severity of a risk?",
    "description": "Likelihood and impact."
  },
  {
    "id": 26,
    "topic_id": 2,
    "title": "What are the two major categories of risk assessment?",
    "description": "Quantitative and qualitative."
  },
  {
    "id": 27,
    "topic_id": 1,
    "title": "What formula is used to calculate the annualized loss expectancy?",
    "description": "ALE = SLE  ARO."
  },
  {
    "id": 28,
    "topic_id": 3,
    "title": "What are the four risk treatment options?",
    "description": "Risk mitigation, risk avoidance, risk acceptance, risk transference."
  },
  {
    "id": 29,
    "topic_id": 3,
    "title": "What term is used to describe the original level of risk facing an organization before implementing any controls?",
    "description": "Inherent risk."
  },
  {
    "id": 30,
    "topic_id": 3,
    "title": "What term is used to describe the risk that remains after an organization implements controls?",
    "description": "Residual risk."
  },
  {
    "id": 31,
    "topic_id": 1,
    "title": "What term is used to describe the level of risk that an organization is willing to accept as a cost of doing business?",
    "description": "Risk appetite or risk tolerance."
  },
  {
    "id": 32,
    "topic_id": 4,
    "title": "What is the primary tool used to track risks within an organization?",
    "description": "Risk register."
  },
  {
    "id": 33,
    "topic_id": 4,
    "title": "What metric is used to track the average amount of time to restore a system to its normal operating state after a failure?",
    "description": "Mean time to repair (MTTR)."
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "What data role is assigned to service providers who handle personal information on behalf of an organization?",
    "description": "Data processor."
  },
  {
    "id": 35,
    "topic_id": 2,
    "title": "What term is commonly used to describe an attacker who acts with permission from the organization being attacked?",
    "description": "White hat or authorized hacker."
  },
  {
    "id": 36,
    "topic_id": 2,
    "title": "What term is commonly used to describe an attacker who has malicious intent?",
    "description": "Black hat or unauthorized hacker."
  },
  {
    "id": 37,
    "topic_id": 2,
    "title": "What derogatory term is used to describe a hacker with a limited skillset?",
    "description": "Script kiddie."
  },
  {
    "id": 38,
    "topic_id": 3,
    "title": "What sophisticated attacker type is often sponsored by a nation-state?",
    "description": "Advanced Persistent Threat (APT)."
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "What type of attack exploits a vulnerability that is unknown to the product vendor?",
    "description": "Zero-day attack."
  },
  {
    "id": 40,
    "topic_id": 3,
    "title": "What term is used to describe the telltale signs that an attack has taken place?",
    "description": "Indicators of Compromise (IoC)."
  },
  {
    "id": 41,
    "topic_id": 1,
    "title": "What XML language is used to describe attack patterns, malware, threat actors, and tools?",
    "description": "Structured Threat Information Expression (STIX)."
  },
  {
    "id": 42,
    "topic_id": 3,
    "title": "What are the two major elements that should be included in the scope of an information security program?",
    "description": "The type of objectives included in the program and the portion of the organization covered by the program."
  },
  {
    "id": 43,
    "topic_id": 2,
    "title": "What portion of an information security program charter contains a statement clearly linking the program\u2019s objectives to the business\u2019 objectives?",
    "description": "Business purpose."
  },
  {
    "id": 44,
    "topic_id": 3,
    "title": "What portion of an information security program charter delegates institutional authority to the CISO?",
    "description": "Statement of authority."
  },
  {
    "id": 45,
    "topic_id": 4,
    "title": "What type of group is commonly used to maintain alignment between security and business objectives?",
    "description": "Steering committee."
  },
  {
    "id": 46,
    "topic_id": 3,
    "title": "What type of metric demonstrates the success of a security program in achieving its objectives?",
    "description": "Key performance indicator (KPI)."
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "What type of metric is used to measure progress toward defined goals?",
    "description": "Key goal indicator (KGI)."
  },
  {
    "id": 48,
    "topic_id": 3,
    "title": "What type of metric is used to quantify the security risk facing an organization?",
    "description": "Key risk indicator (KRI)."
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "What type of security exercise pits technologists against one another in an attempt to attack a system and achieve a specific goal?",
    "description": "Capture-the-flag (CTF) exercise."
  },
  {
    "id": 50,
    "topic_id": 3,
    "title": "What type of professional development helps employees validate their skills in a manner that may be shared with colleagues and potential employers?",
    "description": "Certification."
  },
  {
    "id": 51,
    "topic_id": 3,
    "title": "What are the two major approaches to developing an information security budget?",
    "description": "Zero-based budgeting and incremental budgeting."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "How many months are in a fiscal year?",
    "description": "12."
  },
  {
    "id": 53,
    "topic_id": 3,
    "title": "What type of expense includes the costs of running a business on a day-to-day basis?",
    "description": "Operational expenses (OpEx)."
  },
  {
    "id": 54,
    "topic_id": 4,
    "title": "What type of expense are the costs that an organization incurs as part of building out and maintaining its large assets?",
    "description": "Capital expenses (CapEx)."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "What type of meeting is normally held with departing employees to learn about their experience with the organization?",
    "description": "Exit interview."
  },
  {
    "id": 56,
    "topic_id": 4,
    "title": "What type of tool helps an organization detect security issues due to missing patches and misconfigurations?",
    "description": "Vulnerability scanning."
  },
  {
    "id": 57,
    "topic_id": 4,
    "title": "What considerations are used to determine an appropriate vulnerability scanning frequency?",
    "description": "Risk appetite, regulatory requirements, technical constraints, business constraints, and licensing limitations."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "What parameter may be adjusted to increase or decrease the number of false positive errors during a vulnerability scan?",
    "description": "Scan sensitivity."
  },
  {
    "id": 59,
    "topic_id": 3,
    "title": "What type of vulnerability scanning would be best when attempting to identify SQL injection vulnerabilities?",
    "description": "Web application scanning."
  },
  {
    "id": 60,
    "topic_id": 4,
    "title": "What is a secure replacement for the telnet protocol?",
    "description": "Secure Shell (SSH)."
  },
  {
    "id": 61,
    "topic_id": 1,
    "title": "What is a secure replacement for the FTP protocol?",
    "description": "Secure FTP (SFTP) or FTP Secure (FTPS)."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "What term is used to describe an authorized attempt to defeat an organization\u2019s security controls and perform unauthorized activity?",
    "description": "Penetration test or pentest."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "What type of activity seeks to identify signs of existing malicious activity on a system or network?",
    "description": "Threat hunting."
  },
  {
    "id": 64,
    "topic_id": 3,
    "title": "What type of penetration test best simulates the experience of an actual attacker?",
    "description": "Black box or unknown environment tests."
  },
  {
    "id": 65,
    "topic_id": 2,
    "title": "What document contains the essential parameters of a penetration test?",
    "description": "Rules of Engagement (RoE)."
  },
  {
    "id": 66,
    "topic_id": 1,
    "title": "What type of program allows outsiders to conduct security testing of an organization\u2019s public services and incentivizes that research by offering financial rewards?",
    "description": "Bug bounty program."
  },
  {
    "id": 67,
    "topic_id": 1,
    "title": "What are the two primary mechanisms used by antivirus software?",
    "description": "Signature detection and heuristic detection."
  },
  {
    "id": 68,
    "topic_id": 3,
    "title": "What capabilities does an EDR platform add to traditional antivirus software?",
    "description": "Detecting security incidents."
  },
  {
    "id": 69,
    "topic_id": 4,
    "title": "What are the two major detection mechanisms used by data loss prevention systems?",
    "description": "Pattern matching and watermarking."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "What type of security device is used to enforce rules governing what traffic may enter and leave a network?",
    "description": "Firewall."
  },
  {
    "id": 71,
    "topic_id": 3,
    "title": "What network switch security control is used to segment systems onto different networks depending on their function?",
    "description": "Virtual LANs (VLANs)."
  },
  {
    "id": 72,
    "topic_id": 3,
    "title": "What switch feature may be used to limit the number of MAC addresses that may be active on a given switch port?",
    "description": "Port security."
  },
  {
    "id": 73,
    "topic_id": 2,
    "title": "What security technology may remote users use to create a secure connection to their office network?",
    "description": "Virtual private network (VPN)."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "What are the three major cloud service models?",
    "description": "Infrastructure as a service (IaaS)."
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "What cloud deployment model places workloads from different customers on the same hardware?",
    "description": "Public cloud."
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What type of security solution serves as an intermediary between cloud service users and cloud service providers to enforce an organization\u2019s security policy?",
    "description": "Cloud Access Security Brokers (CASB)."
  },
  {
    "id": 77,
    "topic_id": 3,
    "title": "What key is used to encrypt a message for confidentiality in an asymmetric encryption algorithm?",
    "description": "Recipient\u2019s public key."
  },
  {
    "id": 78,
    "topic_id": 3,
    "title": "What key is used to create a digital signature in an asymmetric encryption algorithm?",
    "description": "Sender\u2019s private key."
  },
  {
    "id": 79,
    "topic_id": 2,
    "title": "What software development approach says that working software is preferable to comprehensive documentation?",
    "description": "Agile."
  },
  {
    "id": 80,
    "topic_id": 2,
    "title": "What approach to software development emphasizes the importance of developers and operations teams working closely together?",
    "description": "DevOps or DevSecOps."
  },
  {
    "id": 81,
    "topic_id": 3,
    "title": "What are the major authentication factors?",
    "description": "Something you know."
  },
  {
    "id": 82,
    "topic_id": 3,
    "title": "What is the best metric to use when evaluating the effectiveness of an authentication mechanism?",
    "description": "Cross-over error rate (CER)."
  },
  {
    "id": 83,
    "topic_id": 1,
    "title": "What is the definition of a security incident?",
    "description": "A security incident is a violation or imminent threat of violation of computer security policies, acceptable use policies, or standard security practices."
  },
  {
    "id": 84,
    "topic_id": 1,
    "title": "What are the four phases of the incident response process?",
    "description": "Preparation."
  },
  {
    "id": 85,
    "topic_id": 2,
    "title": "What NIST document contains guidance on responding to cybersecurity incidents?",
    "description": "NIST 800-61."
  },
  {
    "id": 86,
    "topic_id": 3,
    "title": "What are the major categories of technique used to contain an attack?",
    "description": "Segmentation, isolation, and removal."
  },
  {
    "id": 87,
    "topic_id": 4,
    "title": "What data sanitization technique applies physical or logical techniques that render target data recovery infeasible using state-of-the-art laboratory techniques?",
    "description": "Purging."
  },
  {
    "id": 88,
    "topic_id": 2,
    "title": "What tool can help an incident response team ensure that they do not miss any steps in their standard response process?",
    "description": "Checklist."
  },
  {
    "id": 89,
    "topic_id": 3,
    "title": "What type of investigation is normally performed by law enforcement personnel?",
    "description": "Criminal investigation."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "What evidence principle states that when a document is used as evidence in a court proceeding, the original document must be introduced?",
    "description": "Best evidence rule."
  },
  {
    "id": 91,
    "topic_id": 3,
    "title": "What type of exercise gathers the team in a central location and leads them through a discussion of how they would respond to a given incident scenario?",
    "description": "Tabletop exercise."
  },
  {
    "id": 92,
    "topic_id": 4,
    "title": "What type of business process involves assessing the risks to organizational processes and creating policies, plans, and procedures to minimize the impact those risks might have on the organization if they were to occur?",
    "description": "Business continuity planning (BCP)."
  },
  {
    "id": 93,
    "topic_id": 3,
    "title": "What is the major difference between business continuity planning and disaster recovery planning?",
    "description": "Business continuity activities are typically strategically focused and center themselves on business processes and operations. Disaster recovery plans tend to be more tactical and describe technical activities such as recovery sites, backups, and fault tolerance."
  },
  {
    "id": 94,
    "topic_id": 3,
    "title": "Who are some of the groups that should be included in business continuity planning work?",
    "description": "Representatives from each core business department."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "What are the two different types of business impact analysis?",
    "description": "Quantitative and qualitative."
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "What is the first task during a business impact analysis?",
    "description": "Identifying business priorities."
  },
  {
    "id": 97,
    "topic_id": 1,
    "title": "What measure is used to identify the maximum length of time a business function can tolerate a disruption before suffering irreparable harm?",
    "description": "Maximum tolerable downtime (MTD) or maximum tolerable outage (MTO)."
  },
  {
    "id": 98,
    "topic_id": 1,
    "title": "What formula is used to compute the single loss expectancy?",
    "description": "SLE = AV  EF."
  },
  {
    "id": 99,
    "topic_id": 3,
    "title": "What term describes the use of redundant technology components to allow a system to quickly recover from a failure after experiencing a brief disruption?",
    "description": "High availability."
  },
  {
    "id": 100,
    "topic_id": 2,
    "title": "What RAID level is also known as disk striping with parity?",
    "description": "RAID 5."
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Know the three objectives of cybersecurity.",
    "description": "Confidentiality ensures that unauthorized individuals are not able to gain access to sensitive information. Integrity ensures that there are no unauthorized modifications to information or systems, either intentionally or unintentionally. Availability ensures that information and systems are ready to meet the needs of legitimate users at the time those users request them."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Describe how information security strategies should be aligned with organizational goals and objectives.",
    "description": "As information security managers develop their plans, they should use reliable techniques to assess the current state of the program, such as threat research, SWOT analysis, and gap analysis. They may then identify the initiatives that will move the organization from the current state to its desired state."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Explain how security strategies are influenced by internal and external factors.",
    "description": "Security strategies must be aligned with the business, but they must also incorporate other influences. Information security managers must remain abreast of emerging technologies, social media, the business environment, the organization's risk tolerance, regulatory requirements, third-party considerations, and the threat landscape as they develop, monitor, and revise cybersecurity strategies."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Know why stakeholder commitment and communication are essential to success.",
    "description": "As information security leaders roll out new strategies, they must ensure that they have the support of senior leaders and other stakeholders. They may do this by clearly outlining how information security supports the organization's broader goals and objectives, identifying the business impact of security initiatives, and identifying clear success criteria."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Explain how security controls may be categorized based on their mechanism of action and their intent.",
    "description": "Controls are grouped into the categories of managerial, operational, and technical based on the way that they achieve their objectives. They are divided into the types of preventive, detective, corrective, deterrent, compensating, and physical based on their intended purpose."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Describe the diverse impacts of data breaches on organizations.",
    "description": "When an organization suffers a data breach, the resulting data loss often results in both direct and indirect damages. The organization suffers immediate financial repercussions due to the costs associated with the incident response, as well as long-term financial consequences due to reputational damage. This reputational damage may be difficult to quantify, but it may also have a lasting impact. In some cases, organizations may suffer operational damage if they experience availability damages, preventing them from accessing their own information."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Explain why data must be protected in transit, at rest, and in use.",
    "description": "Attackers may attempt to eavesdrop on network transmissions containing sensitive information. This information is highly vulnerable when in transit unless protected by encryption technology. Attackers also might attempt to breach data stores, stealing data at rest. Encryption serves to protect stored data as well as data in transit. Data is also vulnerable while in use on a system and should be protected during data processing activities."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Know how data loss prevention (DLP) systems block data exfiltration attempts.",
    "description": "DLP technology enforces information handling policies to prevent data loss and theft. DLP systems may function at the host level, using software agents to search systems for the presence of sensitive information. They may also work at the network level, watching for transmissions of unencrypted sensitive information. DLP systems detect sensitive information using pattern-matching technology and/or digital watermarking."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Explain how data minimization reduces risk by reducing the amount of sensitive information that we maintain.",
    "description": "In cases where we cannot simply discard unnecessary information, we can protect information through de-identification and data obfuscation. The tools used to achieve these goals include hashing, tokenization, and masking of sensitive fields."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Governance programs guide and direct security efforts.",
    "description": "Information security governance efforts should integrate with other corporate governance programs to support both the business's goals and its security strategy. Organizations should draw on existing governance frameworks, such as COBIT and the ISO standards, to avoid redundant effort and to align with industry best practices."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Policy frameworks consist of policies, standards, procedures, and guidelines.",
    "description": "Policies are high-level statements of management intent for the information security program. Standards describe the detailed implementation requirements for policies. Procedures offer step-by-step instructions for carrying out security activities. Compliance with policies, standards, and procedures is mandatory. Guidelines offer optional advice that complements other elements of the policy framework."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Organizations often adopt a set of security policies covering different areas of their security programs.",
    "description": "Common policies used in security programs include an information security policy, an acceptable use policy, a data ownership policy, a data retention policy, an account management policy, and a password policy. The specific policies adopted by any organization will depend on that organization's culture and business needs."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Policy documents should include exception processes.",
    "description": "Exception processes should outline the information required to receive an exception to security policy and the approval authority for each exception. The process should also describe the requirements for compensating controls that mitigate risks associated with approved security policy exceptions."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Organizations face a variety of security compliance requirements.",
    "description": "Merchants and credit card service providers must comply with the Payment Card Industry Data Security Standard (PCI DSS). Organizations handling the personal information of European Union residents must comply with the EU General Data Protection Regulation (GDPR). All organizations should be familiar with the national, territory, and state laws that affect their operations."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Standards frameworks provide an outline for structuring and evaluating cybersecurity programs.",
    "description": "Organizations may choose to base their security programs on a framework, such as the NIST Cybersecurity Framework (CSF) or International Organization for Standardization (ISO) standards. U.S. federal government agencies and contractors should also be familiar with the NIST Risk Management Framework (RMF). These frameworks sometimes include maturity models that allow an organization to assess its progress. Some frameworks also offer certification programs that provide independent assessments of an organization's progress toward adopting a framework."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Audits and assessments monitor compliance with requirements.",
    "description": "Audits are externally commissioned, formal reviews of the capability of an organization to achieve its control objectives. Assessments are less rigorous reviews of security issues, often performed or commissioned by IT staff. Organizations providing services to other entities may wish to conduct a service organization controls (SOC) audit under SSAE 18."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Know how risk identification and assessment helps organizations prioritize cybersecurity efforts.",
    "description": "Cybersecurity analysts try to identify all of the risks facing their organization and then conduct a business impact analysis to assess the potential degree of risk based on the probability that it will occur and the magnitude of the potential effect on the organization. This work allows security professionals to prioritize risks and communicate risk factors to others in the organization."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Know that vendors are a source of external risk.",
    "description": "Organizations should conduct their own systems assessments as part of their risk assessment practices, but they should conduct supply chain assessments as well. Performing vendor due diligence reduces the likelihood that a previously unidentified risk at a vendor will negatively impact the organization. Hardware source authenticity techniques verify that hardware was not tampered with after leaving the vendor's premises."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Be familiar with the risk management strategies that organizations may adopt.",
    "description": "Risk avoidance strategies change business practices to eliminate a risk. Risk mitigation techniques reduce the probability or magnitude of a risk. Risk transference approaches move some of the risk to a third party. Risk acceptance acknowledges the risk and continues normal business operations despite the presence of the risk."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Understand how disaster recovery planning builds resiliency.",
    "description": "Disaster recovery plans activate when an organization experiences a natural or human-made disaster that disrupts normal operations. The disaster recovery plan helps the organization quickly recover its information and systems and resume normal operations."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Be familiar with the privacy controls that protect personal information.",
    "description": "Organizations handling sensitive personal information should develop privacy programs that protect that information from misuse and unauthorized disclosure. The plan should cover personally identifiable information (PII), protected health information (PHI), financial information, and other records maintained by the organization that might impact personal privacy."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Be able to describe several key attributes in which threat actors differ.",
    "description": "We can classify threat actors using four major criteria. First, threat actors may be internal to the organization, or they may come from external sources. Second, threat actors differ in their level of sophistication and capability. Third, they differ in their available resources and funding. Finally, different threat actors have different motivations and levels of intent."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Know the many different sources of threat actors.",
    "description": "Threat actors may be very simplistic in their techniques, such as script kiddies using exploit code written by others, or quite sophisticated, such as the advanced persistent threat posed by nation-state actors and criminal syndicates. Hacktivists may seek to carry out political agendas, whereas competitors may seek financial gain. We can group hackers into white-hat, gray-hat, and black-hat categories based on their motivation and authorization."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Be able to explain how attackers exploit different vectors to gain initial access to an organization.",
    "description": "Attackers may attempt to gain initial access to an organization remotely over the Internet, through a wireless connection, or by attempting direct physical access. They may also approach employees over email or social media. Attackers may seek to use removable media to trick employees into unintentionally compromising their networks, or they may seek to spread exploits through cloud services. Sophisticated attackers may attempt to interfere with an organization's supply chain."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Know how threat intelligence provides organizations with valuable insight into the threat landscape.",
    "description": "Security teams may leverage threat intelligence from public and private sources to learn about current threats and vulnerabilities. They may seek out detailed indicators of compromise and perform predictive analytics on their own data. Threat intelligence teams often supplement open source and closed source intelligence that they obtain externally with their own research."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Be able to explain why security teams must monitor supply chain risks.",
    "description": "Modern enterprises depend on hardware, software, and cloud service vendors to deliver IT services to their internal and external customers. Vendor management techniques protect the supply chain against attackers seeking to compromise these external links into an organization's network. Security professionals should pay particular attention to risks posed by outsourced code development, cloud data storage, and integration between external and internal systems."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Be able to describe the purpose of the charter.",
    "description": "The core of the charter is the scope statement, which defines the security objectives included in the program and the portion of the organization covered by the program. The charter should also address the business purpose of the program, a statement of authority, roles and responsibilities, governance structures, documentation, enforcement mechanisms, and processes for periodic program reviews."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Know how metrics are used to assess the efficiency and effectiveness of the information security program.",
    "description": "Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs look at historical performance. Key goal indicators (KGIs) measure progress toward defined goals. Key risk indicators (KRIs) try to quantify the security risk facing an organization. KRIs look forward at future potential risks."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Be able to explain how security training and awareness ensures that individuals understand their responsibilities.",
    "description": "Security training programs impart new knowledge to employees and other stakeholders. They should be tailored to meet the specific requirements of an individual's role in the organization. Security awareness programs seek to remind users of the information they have already learned, keeping their security responsibilities top-of-mind."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Know that security managers are people managers.",
    "description": "Security managers lead a team of professionals and are responsible for the motivation, development, and management of those team members. This includes providing training that helps employees keep their skills current and certifications that help employees validate their skills."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Know that security managers are financial managers.",
    "description": "Security managers bear responsibility for managing a budget allocated to the information security program. They must understand how the fiscal year used by their organization affects funds availability and how to work within the budgeting and accounting processes used by their organization."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Be able to explain how information security must work closely with other business functions.",
    "description": "Security managers should cultivate relationships with other business leaders to ensure that security is well integrated with other business functions. This includes integrating with the human resources function for employee hiring, transfers, and termination. It also includes aligning with procurement and accounting functions for product and service acquisitions. Security leaders should also work carefully with other information technology leaders and the organization's auditors."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Be able to list the vulnerabilities that exist in modern computing environments.",
    "description": "Cybersecurity professionals should remain aware of the risks posed by vulnerabilities both on-premises and in the cloud. Improper or weak patch management can be the source of many of these vulnerabilities, providing attackers with a path to exploit operating systems, applications, and firmware. Weak configuration settings that create vulnerabilities include open permissions, unsecured root accounts, errors, weak encryption settings, insecure protocol use, default settings, and open ports and services. When a scan detects a vulnerability that does not exist, the report is known as a false positive. When a scan does not detect a vulnerability that actually exists, the report is known as a false negative."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Know the purpose of threat hunting.",
    "description": "Threat hunting activities presume that an organization is already compromised and search for indicators of those compromises. Threat hunting efforts include the use of advisories, bulletins, and threat intelligence feeds in an intelligence fusion program. They search for signs that attackers gained initial access to a network and then conducted maneuver activities on that network."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Know the purpose of vulnerability scans.",
    "description": "Vulnerability scans leverage application, network, and web application testing to check for known issues. These scans may be conducted in a credentialed or noncredentialed fashion and may be intrusive or nonintrusive, depending on the organization's needs. Analysts reviewing scans should also review logs and configurations for additional context."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Describe how penetration testing places security professionals in the role of attackers.",
    "description": "Penetration tests may be conducted in a manner that provides the testers with full access to information before the test (white box), no information at all (black box), or somewhere in between those two extremes (gray box). Testers conduct tests within the rules of engagement and normally begin with reconnaissance efforts, including war driving, war flying, footprinting, and open source intelligence (OSINT). They use this information to gain initial access to a system. From there, they seek to conduct privilege escalation to increase their level of access and lateral movement/pivoting to expand their access to other systems. They seek to achieve persistence to allow continued access after the vulnerability they initially exploited is patched. At the conclusion of the test, they conduct cleanup activities to restore systems to normal working order and remove traces of their activity."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Describe how bug bounty programs incentivize vulnerability reporting.",
    "description": "Bug bounty programs allow external security professionals to probe the security of an organization's public-facing systems. Testers who discover vulnerabilities are provided with financial rewards for their participation. This approach is a good way to motivate hackers to work for good, rather than using discovered vulnerabilities against a target."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Know how to use cybersecurity exercises to ensure that teams are prepared for security incidents.",
    "description": "Exercises are designed to test the skills of security professionals. Blue teams are responsible for managing the organization's defenses. Offensive hacking is used by red teams as they attempt to gain access to systems on the target network. White teams serve as the neutral moderators of the exercise. Purple teaming is conducted after an exercise to bring together the red and blue teams for knowledge sharing."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Know the role of endpoint security technologies in an enterprise cybersecurity program.",
    "description": "Antimalware software protects endpoint devices from many different threats. Antimalware software uses signature detection and heuristic detection to prevent malware infections. Endpoint detection and response (EDR) platforms manage the detection, containment, investigation, and remediation of endpoint security incidents. Data loss prevention (DLP) systems prevent the unauthorized exfiltration of sensitive data. Change and configuration management systems maintain secure system configurations, whereas patch management ensures that security updates are consistently applied. System hardening techniques close holes that might be exploited by an attacker."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Explain the role of network segmentation.",
    "description": "Network segmentation techniques place systems and users of different security levels on different network segments, containing the damage caused by a potential security incident. Firewalls provide segmentation of networks into security zones, whereas VLANs group users and devices by function."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Understand the security requirements for routers, switches, and other network devices.",
    "description": "Routers and switches must be protected against unauthorized physical access to avoid compromise. Switch security techniques include VLAN pruning, the prevention of VLAN hopping, and port security. Router security techniques include the use of access control lists to filter traffic and quality of service controls to prioritize important network use."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Explain the three major cloud service models.",
    "description": "In the anything-as-a-service (XaaS) approach to computing, there are three major cloud service models. Infrastructure-as-a-service (IaaS) offerings allow customers to purchase and interact with the basic building blocks of a technology infrastructure. Software-as-a-service (SaaS) offerings provide customers with access to a fully managed application running in the cloud. Platform-as-a-service (PaaS) offerings provide a platform where customers may run applications that they have developed themselves."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Describe the four major cloud deployment models.",
    "description": "Public cloud service providers deploy infrastructure and then make it accessible to any customers who wish to take advantage of it in a multitenant model. The term private cloud is used to describe any cloud infrastructure that is provisioned for use by a single customer. A community cloud service shares characteristics of both the public and private models. Community cloud services do run in a multitenant environment, but the tenants are limited to members of a specifically designed community. Hybrid cloud is a catch-all term used to describe cloud deployments that blend public, private, and/or community cloud services together."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Understand the shared responsibility model of cloud security.",
    "description": "Under the shared responsibility model of cloud security, cloud customers must divide responsibilities between one or more service providers and the customers' own cybersecurity teams. In an IaaS environment, the cloud provider takes on the most responsibility, providing security for everything below the operating system layer. In PaaS, the cloud provider takes over added responsibility for the security of the operating system itself. In SaaS, the cloud provider is responsible for the security of the entire environment, except for the configuration of access controls within the application and the choice of data to store in the service."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Understand secure software development concepts.",
    "description": "Software should be created using a standardized software development lifecycle that moves software through development, test, staging, and production environments. Developers should understand the issues associated with code reuse and software diversity. Web applications should be developed in alignment with industry-standard principles such as those developed by the Open Web Application Security Project (OWASP)."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Explain secure code deployment and automation concepts.",
    "description": "Code repositories serve as a version control mechanism and centralized authority for the secure provisioning and deprovisioning of code. Developers and operations teams should work together on developing automated courses of action as they implement a DevOps approach to creating and deploying software. Software applications should be designed to support both scalability and elasticity."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Understand the goals of cryptography.",
    "description": "The four goals of cryptography are confidentiality, integrity, authentication, and nonrepudiation. Confidentiality is the use of encryption to protect sensitive information from prying eyes. Integrity is the use of cryptography to ensure that data is not maliciously or unintentionally altered. Authentication refers to the uses of encryption to validate the identity of individuals. Nonrepudiation ensures that individuals can prove to a third party that a message came from its purported sender."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Explain the differences between symmetric and asymmetric encryption.",
    "description": "Symmetric encryption uses the same shared secret key to encrypt and decrypt information. Users must have some mechanism to exchange these shared secret keys. Asymmetric encryption provides each user with a pair of keys: a public key, which is freely shared, and a private key, which is kept secret. Anything encrypted with one key from the pair may be decrypted with the other key from the same pair."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Explain how digital signatures provide nonrepudiation.",
    "description": "Digital signatures provide nonrepudiation by allowing a third party to verify the authenticity of a message. Senders create digital signatures by using a hash function to generate a message digest and then encrypting that digest with their own private key. Others may verify the digital signature by decrypting it with the sender's public key and comparing this decrypted message digest to one that they compute themselves using the hash function on the message."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Understand the purpose and use of digital certificates.",
    "description": "Digital certificates provide a trusted mechanism for sharing public keys with other individuals. Users and organizations obtain digital certificates from certificate authorities (CAs), who demonstrate their trust in the certificate by applying their digital signature. Recipients of the digital certificate can rely on the public key it contains if they trust the issuing CA and verify the CA's digital signature."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Explain the major components of an identity and access management program.",
    "description": "Identity and access management systems perform three major functions: identification, authentication, and authorization. Identification is the process of a user making a claim of identity, such as by providing a username. Authentication allows the user to prove their identity. Authentication may be done using something you know, something you have, or something you are. Multifactor authentication combines different authentication techniques to provide stronger security. Authorization ensures that authenticated users may only perform actions necessary to carry out their assigned responsibilities."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Security events are occurrences that may escalate into a security incident.",
    "description": "An event is any observable occurrence in a system or network. A security event includes any observable occurrence that relates to a security function. A security incident is a violation or imminent threat of violation of computer security policies, acceptable use policies, or standard security practices. Every incident consists of one or more events, but every event is not an incident."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "The cybersecurity incident response process has four phases.",
    "description": "The four phases of incident response are preparation; detection and analysis; containment, eradication, and recovery; and post-incident activities. The process is not a simple progression of steps from start to finish. Instead, it includes loops that allow responders to return to prior phases as needed during the response."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Security event indicators include alerts, logs, publicly available information, and people.",
    "description": "Alerts originate from intrusion detection and prevention systems, security information and event management systems, antivirus software, file integrity checking software, and third-party monitoring services. Logs are generated by operating systems, services, applications, network devices, and network flows. Publicly available information exists about new vulnerabilities and exploits detected \u201cin the wild\u201d or in a controlled laboratory environment. People from inside the organization or external sources report suspicious activity that may indicate that a security incident is in progress."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Policies, procedures, and playbooks guide incident response efforts.",
    "description": "The incident response policy serves as the cornerstone of an organization's incident response program. This policy should be written to guide efforts at a high level and provide the authority for incident response. Procedures provide the detailed, tactical information that CSIRT members need when responding to an incident. CSIRTs often develop playbooks that describe the specific procedures that they will follow in the event of a specific type of cybersecurity incident."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Incident response teams should represent diverse stakeholders.",
    "description": "The core incident response team normally consists of cybersecurity professionals with specific expertise in incident response. In addition to the core team members, the CSIRT may include representation from technical subject matter experts, IT support staff, legal counsel, human resources staff, and public relations and marketing teams."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Incidents may be classified according to the attack vector where they originate.",
    "description": "Common attack vectors for security incidents include external/removable media, attrition, the web, email, impersonation, improper usage, loss or theft of equipment, and other/unknown sources."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Response teams classify the severity of an incident.",
    "description": "The functional impact of an incident is the degree of impairment that it causes to the organization. The economic impact is the amount of financial loss that the organization incurs. In addition to measuring the functional and economic impact of a security incident, organizations should measure the time that services will be unavailable and the recoverability effort. Finally, the nature of the data involved in an incident also contributes to the severity of the information impact."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Understand the four steps of the business continuity planning process.",
    "description": "Business continuity planning involves four distinct phases: project scope and planning, business impact analysis, continuity planning, and approval and implementation. Each task contributes to the overall goal of ensuring that business operations continue uninterrupted in the face of an emergency."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Describe how to perform the business organization analysis.",
    "description": "In the business organization analysis, the individuals responsible for leading the BCP process determine which departments and individuals have a stake in the business continuity plan. This analysis serves as the foundation for BCP team selection and, after validation by the BCP team, is used to guide the next stages of BCP development."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "List the necessary members of the business continuity planning team.",
    "description": "The BCP team should contain, at a minimum, representatives from each of the operational and support departments; technical experts from the IT department; physical and IT security personnel with BCP skills; legal representatives familiar with corporate legal, regulatory, and contractual responsibilities; and representatives from senior management. Additional team members depend on the structure and nature of the organization."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Know the legal and regulatory requirements that face business continuity planners.",
    "description": "Business leaders must exercise due diligence to ensure that shareholders' interests are protected in the event disaster strikes. Some industries are also subject to federal, state, and local regulations that mandate specific BCP procedures. Many businesses also have contractual obligations to their clients that they must meet before, during, and after a disaster."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Explain the steps of the business impact analysis process.",
    "description": "The five stages of the business impact analysis process are the identification of priorities, risk identification, likelihood assessment, impact analysis, and resource prioritization."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Describe the process used to develop a continuity strategy.",
    "description": "During the strategy development phase, the BCP team determines which risks they will mitigate. In the provisions and processes phase, the team designs mechanisms and procedures that will mitigate identified risks. The plan must then be approved by senior management and implemented. Personnel must also receive training on their roles in the BCP process."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Explain the importance of comprehensively documenting an organization's business continuity and disaster recovery plans.",
    "description": "Committing the plan to writing provides the organization with a written record of the procedures to follow when disaster strikes. It prevents the \u201cit's in my head\u201d syndrome and ensures the orderly progress of events in an emergency."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Be familiar with the common types of recovery facilities.",
    "description": "The common types of recovery facilities are cold sites, warm sites, hot sites, mobile sites, and multiple sites. Be sure you understand the benefits and drawbacks for each such facility."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Understand the technologies that may assist with database backup.",
    "description": "Databases benefit from three backup technologies. Electronic vaulting is used to transfer database backups to a remote site as part of a bulk transfer. In remote journaling, data transfers occur on a more frequent basis. With remote mirroring technology, database transactions are mirrored at the backup site in real time."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "Explain the common processes used in disaster recovery programs.",
    "description": "These programs should take a comprehensive approach to planning and include considerations related to the initial response effort, personnel involved, communication among the team and with internal and external entities, assessment of response efforts, and restoration of services. DR programs should also include training and awareness efforts to ensure personnel understand their responsibilities and lessons learned sessions to continuously improve the program."
  },
  {
    "id": 169,
    "topic_id": 200,
    "title": "Know the five types of disaster recovery plan tests and the impact each has on normal business operations.",
    "description": "The five types of disaster recovery plan tests are: read-through tests, structured walk-throughs, simulation tests, parallel tests, and full-interruption tests. Checklist tests are purely paperwork exercises, whereas structured walk-throughs involve a project team meeting. Neither has an impact on business operations. Simulation tests may shut down noncritical business units. Parallel tests involve relocating personnel but do not affect day-to-day operations. Full-interruption tests involve shutting down primary systems and shifting responsibility to the recovery facility."
  }
];
